var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAcknowlegedIcon = function SvgAcknowlegedIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8321 5.68232C18.2358 6.05915 18.2576 6.69194 17.8808 7.09569L10.7009 14.7884L7.5547 10.0691C7.24835 9.60954 7.37252 8.98867 7.83205 8.68232C8.29158 8.37597 8.91245 8.50014 9.2188 8.95967L10.9632 11.5762L16.4187 5.73106C16.7955 5.3273 17.4283 5.30548 17.8321 5.68232Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.67506 13.9784C6.38612 15.0659 7.43096 15.8931 8.65252 16.3358C9.87408 16.7785 11.2063 16.8127 12.449 16.4333C13.6917 16.0539 14.7776 15.2813 15.5435 14.2317C16.3094 13.1822 16.7139 11.9124 16.6963 10.6132C16.6888 10.061 17.1303 9.60721 17.6826 9.59969C18.2348 9.59218 18.6886 10.0338 18.6961 10.586C18.7197 12.3182 18.1803 14.0113 17.1591 15.4107C16.1378 16.8101 14.6899 17.8402 13.0331 18.3461C11.3762 18.852 9.59983 18.8064 7.97109 18.2162C6.34235 17.6259 4.94922 16.5229 4.00114 15.0729C3.05306 13.623 2.60127 11.9045 2.71369 10.1757C2.8261 8.44695 3.49665 6.80141 4.62452 5.48645C5.7524 4.1715 7.27664 3.25819 8.96811 2.88384C10.6596 2.50948 12.4269 2.69431 14.0043 3.41054C14.5072 3.63887 14.7297 4.23163 14.5014 4.73451C14.273 5.23738 13.6803 5.45994 13.1774 5.23161C11.9944 4.69444 10.6689 4.55582 9.40029 4.83658C8.13169 5.11735 6.98851 5.80233 6.1426 6.78855C5.2967 7.77476 4.79378 9.00892 4.70947 10.3055C4.62516 11.602 4.964 12.8909 5.67506 13.9784Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAcknowlegedIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/acknowleged-icon.3c5c3027.svg";
export { ForwardRef as ReactComponent };